import axios from 'axios';
import { fetchAuthSession } from '@aws-amplify/auth';
import type { InternalAxiosRequestConfig } from 'axios';

const axiosInstance = axios.create({
  timeout: 60000,
});

axiosInstance.interceptors.request.use(async (config: InternalAxiosRequestConfig<any>) => {
  // console.log(config);
  if (config.headers !== undefined) {
    const authSession = await fetchAuthSession();
    const token = authSession?.tokens?.idToken?.toString();
    // console.log(token);
    if (token) {
      config.headers.Authorization = 'Bearer ' + token;
    }
  }
  return config;
});

export default axiosInstance;
